import { useState } from 'react';

interface ShipRecord {
  id: string;
  shipName: string;
  berthNo: string;
  operation: string;
  startTime: string;
  endTime: string;
  status: string;
}

export default function ShipAssist() {
  const [records] = useState<ShipRecord[]>([
    { id: 'S001', shipName: '远洋货轮-001', berthNo: '1号泊位', operation: '靠泊', startTime: '2025-01-15 08:30', endTime: '2025-01-15 09:15', status: '已完成' },
    { id: 'S002', shipName: '集装箱船-A23', berthNo: '3号泊位', operation: '离泊', startTime: '2025-01-15 10:00', endTime: '2025-01-15 10:45', status: '已完成' },
    { id: 'S003', shipName: '散货船-B56', berthNo: '5号泊位', operation: '靠泊', startTime: '2025-01-15 11:20', endTime: '进行中', status: '进行中' },
    { id: 'S004', shipName: '油轮-C89', berthNo: '7号泊位', operation: '离泊', startTime: '2025-01-15 14:00', endTime: '待开始', status: '待开始' },
  ]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-white">船舶进出港辅助</h2>
        <button className="px-4 py-2 bg-teal-500 text-white text-sm rounded-lg hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer">
          <i className="ri-add-line mr-2"></i>新增任务
        </button>
      </div>

      <div className="grid grid-cols-3 gap-4">
        <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-slate-400 text-sm">今日靠泊</span>
            <i className="ri-ship-line text-teal-400 text-xl"></i>
          </div>
          <div className="text-2xl font-bold text-white">12</div>
          <div className="text-xs text-teal-400 mt-1">+3 较昨日</div>
        </div>

        <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-slate-400 text-sm">今日离泊</span>
            <i className="ri-ship-2-line text-teal-400 text-xl"></i>
          </div>
          <div className="text-2xl font-bold text-white">8</div>
          <div className="text-xs text-slate-400 mt-1">-1 较昨日</div>
        </div>

        <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-slate-400 text-sm">进行中</span>
            <i className="ri-time-line text-orange-400 text-xl"></i>
          </div>
          <div className="text-2xl font-bold text-orange-400">1</div>
          <div className="text-xs text-slate-500 mt-1">实时监控</div>
        </div>
      </div>

      <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-white mb-4">实时靠泊画面</h3>
        <div className="aspect-video bg-slate-900 rounded-lg overflow-hidden relative">
          <img 
            src="https://public.readdy.ai/ai/img_res/8016ba82a0a7ae70a0796837eccc1300.jpg"
            alt="实时靠泊画面"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute top-4 left-4 bg-red-500 text-white px-3 py-1 rounded-full text-xs font-medium flex items-center">
            <span className="w-2 h-2 bg-white rounded-full mr-2 animate-pulse"></span>
            实时直播
          </div>
          <div className="absolute bottom-4 left-4 right-4 bg-slate-900/80 backdrop-blur-sm rounded-lg p-3">
            <div className="flex items-center justify-between text-sm">
              <span className="text-white font-medium">散货船-B56 靠泊作业</span>
              <span className="text-slate-400">5号泊位 | 11:20 开始</span>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-slate-800/50 border border-slate-700 rounded-lg overflow-hidden">
        <div className="px-6 py-4 border-b border-slate-700">
          <h3 className="text-lg font-semibold text-white">操作记录</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-slate-900/50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">任务编号</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">船舶名称</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">泊位</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">操作类型</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">开始时间</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">结束时间</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">状态</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">操作</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-700">
              {records.map((record) => (
                <tr key={record.id} className="hover:bg-slate-700/30 transition-colors">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-white">{record.id}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-300">{record.shipName}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-300">{record.berthNo}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-300">{record.operation}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-300">{record.startTime}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-300">{record.endTime}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <span className={`px-2 py-1 rounded-full text-xs ${
                      record.status === '已完成' ? 'bg-teal-500/20 text-teal-400' :
                      record.status === '进行中' ? 'bg-orange-500/20 text-orange-400' :
                      'bg-slate-500/20 text-slate-400'
                    }`}>
                      {record.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <button className="text-teal-400 hover:text-teal-300 mr-3 cursor-pointer">
                      <i className="ri-video-line"></i>
                    </button>
                    <button className="text-slate-400 hover:text-slate-300 cursor-pointer">
                      <i className="ri-file-text-line"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
